import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";
import $ from "jquery";
import { minDate } from "../../Constants/Constants";

const UpdateMaterialDispatch = ({ formRef, getData, rowId, setRowId }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [company, setCompany] = useState([]);
  const [closingStockInYard, setClosingStockInYard] = useState("");
  const [singleGovtOrderNumber, setSingleGovtOrderNumber] = useState([]);
  const [tripExistId, setTripExistId] = useState("");
  const [existFlag, setExistFlag] = useState(false);
  const [vehicle, setVehicle] = useState([]);
  const [vehicleNumber, setVehicleNumber] = useState("");
  const [materialName, setMaterialName] = useState([]);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setCompany(result.data);
    } else {
      setCompany([]);
    }
  };

  useEffect(() => {
    getCompany();
  }, []);
  const getVehicle = async () => {
    const BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setVehicle(result.data);
    } else {
      setVehicle([]);
    }
  };

  useEffect(() => {
    getVehicle();
  }, []);
  const getMaterialName = async () => {
    const BASE_URL =
      SERVER_URL + `/api/raw-mat-name/all-material-names/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setMaterialName(result.data);
    } else {
      setMaterialName([]);
    }
  };

  useEffect(() => {
    getMaterialName();
  }, []);
  useEffect(() => {
    if (singleGovtOrderNumber) {
      setVehicleNumber(singleGovtOrderNumber?.vehicleDetails?.id);
    }
  }, [singleGovtOrderNumber]);

  const handleVehicleChange = (e) => {
    setVehicleNumber(e.target.value);
  };

  useEffect(() => {
    if (rowId) {
      handleSingleGovtOrderNumber();
    }
  }, [rowId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSingleGovtOrderNumber(() => {
      return {
        ...singleGovtOrderNumber,
        [name]: value,
      };
    });
  };

  const handleSingleGovtOrderNumber = async () => {
    let BASE_URL =
      SERVER_URL +
      `/api/material-dispatch/single-material-dispatch/${user_id}?dispatch_order_id=${rowId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setSingleGovtOrderNumber(result.data);
    } else {
      setSingleGovtOrderNumber([]);
    }
  };

  const getTripExist = async () => {
    const BASE_URL = `${SERVER_URL}/api/trips/trip-exist/${user_id}?vehicle_details_id=${vehicleNumber}&dispatch_date=${singleGovtOrderNumber.dispatch_date}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      toast.dismiss();
      setTripExistId(result.data.id);
      setExistFlag(true);
    } else {
      setTripExistId("");
      setExistFlag(false);
      toast.error(result.message);
    }
  };

  useEffect(() => {
    if (vehicleNumber && singleGovtOrderNumber.dispatch_date) {
      getTripExist();
    }
  }, [vehicleNumber, singleGovtOrderNumber.dispatch_date]);

  // const handleSave = (e) => {
  //   e.preventDefault();
  //   console.log(orderNumbers);
  // };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      id,
      dispatch_date,
      gp_number,
      party_name,
      company_id,
      material_name_id,
      total_dispatch_qty,
      remarks,
      party_name_company_name_id,
    } = singleGovtOrderNumber;
    if (!existFlag) {
      toast.error(
        "Please check the existence of trip over the dispatch date and vehicle number"
      );
      return;
    }
    let BASE_URL =
      SERVER_URL + `/api/material-dispatch/material-dispatch/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        dispatch_date,
        gp_number,
        vehicle_details_id: vehicleNumber,
        party_name,
        company_id,
        party_name_company_name_id,
        material_name_id,
        total_dispatch_qty,
        trip_id: tripExistId,
        remarks,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      resetFields();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  function resetFields() {
    setSingleGovtOrderNumber({
      dispatch_date: "",
      gp_number: "",
      party_name: "",
      company_id: "",
      material_name_id: "",
      total_dispatch_qty: "",
      remarks: "",
      party_name_company_name_id: "",
    });
    setRowId("");
    setTripExistId("");
    setVehicleNumber("");
  }
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update Material Dispatch
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {/* <div style={{ textAlign: "center" }} className="mb-4">
                <h6>
                  <i className="fa fa-info-circle"></i> Stock in Yard for
                  selected details :{" "}
                  <span style={{ fontSize: "18px" }}>
                    {closingStockInYard
                      ? closingStockInYard?.p_closing_stock
                      : 0}
                  </span>
                </h6>
              </div> */}
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleAddDataSubmit}
                    >
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_id">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              value={singleGovtOrderNumber?.company_id}
                              onChange={handleChange}
                              id="company_id"
                              name="company_id"
                              disabled
                            >
                              <option value="">Select Company</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => (
                                  <option
                                    key={id}
                                    value={item.id}
                                  >{`${item.company_name}, ${item.location}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="material_name_id">
                              Material Name
                            </label>
                            <select
                              className="form-control form-control-lg"
                              value={singleGovtOrderNumber.material_name_id}
                              onChange={handleChange}
                              id="material_name_id"
                              name="material_name_id"
                              disabled
                            >
                              <option value="">Select Material</option>
                              {materialName &&
                                materialName?.length > 0 &&
                                materialName?.map((item, id) => (
                                  <option key={id} value={item.id}>
                                    {item.material_name}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="total_dispatch_qty">
                              Dispatch Qty
                            </label>
                            <div className="input-group">
                              <input
                                type="number"
                                className="form-control"
                                name="total_dispatch_qty"
                                id="total_dispatch_qty"
                                placeholder="Dispatch Qty"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={singleGovtOrderNumber.total_dispatch_qty}
                                required
                                autoComplete="off"
                                min="0"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="GP">GP Number</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="gp_number"
                                id="GP"
                                placeholder="GP Number"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.gp_number}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="company_id">For Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              value={
                                singleGovtOrderNumber?.party_name_company_name_id
                              }
                              onChange={handleChange}
                              id="company_id"
                              name="party_name_company_name_id"
                              disabled
                            >
                              <option value="">Select Company</option>
                              {company &&
                                company?.length > 0 &&
                                company?.map((item, id) => (
                                  <option
                                    key={id}
                                    value={item.id}
                                  >{`${item.company_name}, ${item.location}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Date">Dispatch Date</label>
                            <div className="input-group">
                              <input
                                type="date"
                                className="form-control"
                                name="dispatch_date"
                                id="Date"
                                placeholder="dispatch_date"
                                max={new Date().toISOString().split("T")[0]}
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.dispatch_date}
                                required
                                autoComplete="off"
                                min={minDate}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Vehicle">Vehicle Number</label>
                            <select
                              className="form-control form-control-lg"
                              value={vehicleNumber}
                              onChange={handleVehicleChange}
                              id="Vehicle"
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => (
                                  <option
                                    key={id}
                                    value={item.id}
                                  >{`${item.vehicle_number}`}</option>
                                ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="remarks">Remarks</label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="remarks"
                                id="remarks"
                                placeholder="Remarks"
                                onChange={handleChange}
                                value={singleGovtOrderNumber?.remarks}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateMaterialDispatch;
